// 데모 계정(username: demo)의 칸 선택. BE `/api/farms/{id}/cell-selection` 을 타지 않고
// 브라우저 localStorage 에만 둔다.
//
// 실계정에서 칸 선택은 농장 단위 공유 값이다. 서버가 들고 있고 바뀌면 STOMP 로 접속 중인
// 모든 화면에 내려간다. 데모가 그 경로를 그대로 타면 시연 중 누른 칸이 실제 농장의 선택을
// 덮어쓰고, 같은 농장을 보는 다른 계정 화면까지 따라 바뀐다. 그래서 여기서 끊는다.
//
// 칸 자체(id·좌표)는 여전히 실제 API 가 준다. 여기서 로컬로 두는 건 "무엇을 골랐는가" 뿐이다.
// 농장별로 나눠 담는다 — 농장을 바꿔 가며 시연할 때 선택이 섞이면 안 된다.

const STORAGE_KEY = "demo-cell-selection";

const readAll = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    // 사생활 보호 모드 등에서 읽기가 막혀도 시연은 계속돼야 한다.
    return {};
  }
};

const writeAll = (map) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // 저장 실패는 화면 동작을 막지 않는다. 새로고침하면 선택이 사라질 뿐이다.
  }
};

const keyOf = (farmId) => String(farmId ?? "");

export const readDemoCellSelection = (farmId) => {
  if (farmId == null) return [];
  const list = readAll()[keyOf(farmId)];
  return Array.isArray(list) ? list : [];
};

export const writeDemoCellSelection = (farmId, cellIds) => {
  const next = Array.isArray(cellIds) ? [...cellIds] : [];
  if (farmId == null) return next;
  const map = readAll();
  map[keyOf(farmId)] = next;
  writeAll(map);
  return next;
};

// 실계정 PATCH 와 같은 계약: 바뀐 뒤의 "전체 목록"을 돌려준다.
// 받는 쪽에서 합치는 계산이 없어야 한 번 놓쳐도 다음 값에서 저절로 맞는다.
export const toggleDemoCell = (farmId, cellId, selected) => {
  const current = readDemoCellSelection(farmId);
  const has = current.some((id) => String(id) === String(cellId));
  if (selected && has) return current;
  if (!selected && !has) return current;
  const next = selected
    ? [...current, cellId]
    : current.filter((id) => String(id) !== String(cellId));
  return writeDemoCellSelection(farmId, next);
};

export const clearDemoCellSelection = (farmId) => writeDemoCellSelection(farmId, []);
